<template>
  <div class="loading-state flex flex-col items-center justify-center py-12 px-4">
    <div class="loading-spinner mb-4">
      <div class="spinner-ring"></div>
      <div class="spinner-icon">
        <i class="fas fa-trophy text-2xl text-purple-600"></i>
      </div>
    </div>
    <p class="text-gray-600 text-lg font-medium">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    message: {
      type: String,
      default: 'Loading leaderboard...'
    }
  }
}
</script>

<style scoped>
.loading-spinner {
  position: relative;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(102, 126, 234, 0.1);
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-icon {
  position: relative;
  z-index: 1;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.9);
  }
}
</style>
